import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

const FieldMessages = ({ className, errorMessage, infoMessage, isHTML = false }) => {
  // debugger;
  if (errorMessage) {
    return <span
      className={classNames('gn-fieldMessage gn-fieldMessage--error', className)}
      {...(isHTML && { dangerouslySetInnerHTML: { __html: errorMessage } })}
    >
      {!isHTML ? errorMessage : null}
    </span>;
  }

  if (infoMessage) {
    return <span
      className={classNames('gn-fieldMessage gn-fieldMessage--info', className)}
      {...(isHTML && { dangerouslySetInnerHTML: { __html: infoMessage } })}
    >
      {!isHTML ? infoMessage : null}
    </span>;
  }

  return null;
};

FieldMessages.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  infoMessage: PropTypes.string,
  isHTML: PropTypes.bool,
};

export default FieldMessages;
